import FilingStep from './filing-step.vue';
import HoldCourtStep from './hold-court-step.vue';
import CloseCaseStep from './close-case-step.vue';
import EnclosureStep from './enclosure-step.vue';
import ImplementStep from './implement-step.vue';
export var component = {
    FilingStep: FilingStep,
    HoldCourtStep: HoldCourtStep,
    ImplementStep: ImplementStep,
    CloseCaseStep: CloseCaseStep,
    EnclosureStep: EnclosureStep,
};
export var steps = [
    {
        label: 'filing-step',
        name: '立案',
        component: "FilingStep"
    },
    {
        label: 'hold-court-step',
        name: '开庭',
        component: "HoldCourtStep"
    },
    {
        label: 'implement-step',
        name: '执行',
        component: "ImplementStep"
    },
    {
        label: 'close-case-step',
        name: '结案',
        component: "CloseCaseStep"
    },
    {
        label: 'enclosure-step',
        name: '附件',
        component: "EnclosureStep"
    }
];
